module.exports = __webpack_public_path__ + "img/tree-01-f-leaves.b802b46c.png";